import React, { useContext, useState} from "react";
import {Alert, Spin, Tabs} from "antd";
import MapPropsContext from "../MapPropsContext";
import Axios from "axios";
import useDebounce from "../../../utils/hooks/useDebounce";
import {getApiHost} from "../../../utils";
import useRMateChart from "./useRMateChart";
import ChartPane from "./ChartPane";


function RMateChartStatsCellular({ disabled }) {
  const {
    chartAjaxParams,
    chartDivVisible,
  } = useContext(MapPropsContext);

  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [parsedObject, setParsedObject] = useState({});
  const {
    searchStart, searchEnd, sidoCode, searchChk, chkRadSvcString, prm_check_all, prm_check,
  } = chartAjaxParams;
  const [prevParams, setPrevParmas] = useState({});


  useDebounce(() => {
    if ( isInit ) {
      const url = getApiHost() + '/rwdinfolabstats/getYearBySvcBySm.do.json';

      const params = ({
        sidoCode,
        searchStart,
        searchEnd,
        searchChk,
        chkRadSvcString,
        prm_check_all,
      });

      if ( chartDivVisible === false && (JSON.stringify(params) !== JSON.stringify(prevParams))){
        setPrevParmas(params);
        setIsLoading(true);
        setParsedObject({}); // 초기화

        Axios.get(url, { params })
          .then(({ data }) => {
            const { itemSm, itemSm10 } = data;  // 외 itemLagend
            const chart1Data = getChart1Data(itemSm);
            const chart2Data = getChart2Data(itemSm10);
            setParsedObject({ chart1Data, chart2Data });
          })
          .catch(e => console.error(e))
          .finally(() => {
            setIsLoading(false);
          })
      }
    }
  }, 1000,
    [isInit, chartAjaxParams, setIsLoading, setParsedObject]);

  const { chart1Data, chart2Data } = parsedObject;

  return useRMateChart({
    init: () => {
      setIsInit(true);
    },
    style: {minHeight: '540px'},
    disabled,
    children: (
      <div style={{ position: 'relative', height: '100%' }}>
        {/*{isLoading && <Spin style={{ position: 'absolute', left: '50%', top: '50%', zIndex: 1 }} size={"large"}/>}*/}
         {isLoading &&
          <div style={{position: 'absolute', top: 55, zIndex: 1, height: '90%', width: '100%', backgroundColor: 'white'}}>
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{height: '470px'}}
              />
            </Spin>
          </div>
        }
        <Tabs defaultActiveKey={"1"} type={"card"}>
          <Tabs.TabPane tab="서비스별 무선국 수" key={"1"}>
            <ChartPane data={chart1Data}
                       processor={() => chart1Data}
                       layoutProcessor={() => getChart1Layout(prm_check, searchEnd)}
                       style={
                         chart1Data && chart1Data.length > 16
                           ? {height: chart1Data.length * 30}
                           : {height:  470}
                       } />
          </Tabs.TabPane>

          <Tabs.TabPane tab="년(월)간 서비스별 무선국 변동" key={"2"}>
            <ChartPane data={chart2Data}
                       processor={() => chart2Data}
                       layoutProcessor={() => {
                         return getChart2Layout(searchStart, searchEnd, searchChk, prm_check);
                       }}
                       style={chart2Data && chart2Data.length > 23
                           ? {height:  470,width: chart2Data.length * 30}
                           : { height:  470,width: '100%'}}/>
          </Tabs.TabPane>
        </Tabs>
      </div>
    )
  });
}


/// 차트 정의시 필요한 펑션

function chartColor(displayName) {
  if (displayName.indexOf('간이무선국') !== -1) return "#41b2e6";
  else if (displayName.indexOf('고정국') !== -1) return "#4452a8";
  else if (displayName.indexOf('기지국') !== -1) return "#fabc05";
  else if (displayName.indexOf('선박국') !== -1) return "#5587a2";
  else if (displayName.indexOf('아마추어국') !== -1) return "#69cabc";
  else if (displayName.indexOf('육상이동국') !== -1) return "#6c4a85";
  else if (displayName.indexOf('의무선박국') !== -1) return "#8a7860";
  else if (displayName.indexOf('이동중계국') !== -1) return "#f7a33b";
  else if (displayName.indexOf('전파응용설비') !== -1) return "#d8c6aa";
  else if (displayName.indexOf('이동국') !== -1) return "#68c0c9";
  else if (displayName.indexOf('기타') !== -1) return "#999999";
  else if (displayName.indexOf('2G') !== -1) return "#41b2e6";
  else if (displayName.indexOf('3G') !== -1) return "#4452a8";
  else if (displayName.indexOf('LTE') !== -1) return "#fabc05";
  else if (displayName.indexOf('5G') !== -1) return "#acacac";
  else return "#cccccc";
}

function insertComma(n) {
  let reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, `$1,$2`);
  return n;
}

function ChartRow() {
  this.YEAR = null;
  this.LEG_DNR_CD = null;
  this.LEG_DNR_NM = null;
  this.SM_2G = null; //2G
  this.SM_3G = null; //3G
  this.SM_LTE = null; //LTE
  this.SM_5G = null; //5G
  this.SM_2G_str = null; //2G
  this.SM_3G_str = null; //3G
  this.SM_LTE_str = null; //LTE
  this.SM_5G_str = null; //5G
}

// 데이터 수정 - 서비스별 무선국 수
const getChart1Data = (dataList) => {
  let _staData;

  if (dataList) {
    let tmpChartRow;
    let NOW_LEG_DNR_CD = "";

    let tmpAry = [];

    for (let i = 0; i < dataList.length; ++i) {

      const item = dataList[i];

      if (i === 0) {
        tmpChartRow = new ChartRow();
        NOW_LEG_DNR_CD = item.LEG_DNR_CD;
        tmpChartRow.SM_TOTAL = 0;
      }

      if (NOW_LEG_DNR_CD !== item.LEG_DNR_CD) {

        tmpAry.push(tmpChartRow);
        tmpChartRow = new ChartRow();
        NOW_LEG_DNR_CD = item.LEG_DNR_CD;
        tmpChartRow.SM_TOTAL = 0;
      }

      tmpChartRow.LEG_DNR_CD = item.LEG_DNR_CD;
      tmpChartRow.LEG_DNR_NM = item.LEG_DNR_NM;

      switch (item.SERVICE_CD) {
        case '2G' :
          tmpChartRow.SM_2G = item.CNT;
          tmpChartRow.SM_2G_str = insertComma(item.CNT);
          tmpChartRow.SM_TOTAL += Number(item.CNT);
          break;
        case '3G' :
          tmpChartRow.SM_3G = item.CNT;
          tmpChartRow.SM_3G_str = insertComma(item.CNT);
          tmpChartRow.SM_TOTAL += Number(item.CNT);
          break;
        case 'LTE' :
          tmpChartRow.SM_LTE = item.CNT;
          tmpChartRow.SM_LTE_str = insertComma(item.CNT);
          tmpChartRow.SM_TOTAL += Number(item.CNT);
          break;
        case '5G' :
          tmpChartRow.SM_5G = item.CNT;
          tmpChartRow.SM_5G_str = insertComma(item.CNT);
          tmpChartRow.SM_TOTAL += Number(item.CNT);
          break;
        // no default
      }

    }
    if (dataList.length > 0) {

      tmpAry.push(tmpChartRow);
    }

    if (tmpAry !== null && tmpAry.length > 0) {
      _staData = tmpAry;
    // 크기순 정렬
      _staData.sort(function (a, b) {
        return a.SM_TOTAL < b.SM_TOTAL ? -1 : a.SM_TOTAL > b.SM_TOTAL ? 1 : 0;
      });
      return _staData;
    } else {
      return [];
    }
  }
};

// 데이터 세팅 - 년월간 서비스별 변동
const getChart2Data = (dataList, searchChk) => {
  let _staData10YearChart;
  if (dataList) {
    let minYear = "";
    // eslint-disable-next-line no-unused-vars
    let maxYear = "";

    let tmpChartRow10YearC;
    let NOW_YEAR = "";
    let first = true;
    let secondMonth = "";//월별로 조회시 전월대비용으로 가져온 전월데이터 제외한 다음 두번째달을 시작월로 표시하기위해

    let tmpAry10YearC = [];

    for (let i = 0; i < dataList.length; ++i) {

      const item = dataList[i];

      if (searchChk === "Y") {
        //년도별 검색일때
        if (i === 0) {
          minYear = item.YEAR;
        }
        if (minYear <= item.YEAR) {
          if (first) {
            tmpChartRow10YearC = new ChartRow();
            NOW_YEAR = item.YEAR;
            tmpChartRow10YearC.YEAR = item.YEAR;
            first = false;
          }
          if (NOW_YEAR !== item.YEAR) {

            tmpAry10YearC.push(tmpChartRow10YearC);
            tmpChartRow10YearC = new ChartRow();
            NOW_YEAR = item.YEAR;
            tmpChartRow10YearC.YEAR = item.YEAR;
          }

          switch (item.SERVICE_CD) {
            case '2G' :
              tmpChartRow10YearC.SM_2G = item.CNT;
              tmpChartRow10YearC.SM_2G_str = insertComma(item.CNT);
              break;
            case '3G' :
              tmpChartRow10YearC.SM_3G = item.CNT;
              tmpChartRow10YearC.SM_3G_str = insertComma(item.CNT);
              break;
            case 'LTE' :
              tmpChartRow10YearC.SM_LTE = item.CNT;
              tmpChartRow10YearC.SM_LTE_str = insertComma(item.CNT);
              break;
            case '5G' :
              tmpChartRow10YearC.SM_5G = item.CNT;
              tmpChartRow10YearC.SM_5G_str = insertComma(item.CNT);
              break;
            // no default
          }

          maxYear = item.YEAR;
        }
      } else {
        if (i === 0) {
          minYear = item.YEARMM;
        }
        if (minYear <= item.YEARMM) {
          if (first) {
            tmpChartRow10YearC = new ChartRow();
            NOW_YEAR = item.YEARMM;
            tmpChartRow10YearC.YEAR = item.YEARMM;
            first = false;
            secondMonth = item.YEARMM;
          }
          if (NOW_YEAR !== item.YEARMM) {

            tmpAry10YearC.push(tmpChartRow10YearC);
            tmpChartRow10YearC = new ChartRow();
            NOW_YEAR = item.YEARMM;
            tmpChartRow10YearC.YEAR = item.YEARMM;
          }

          switch (item.SERVICE_CD) {
            case '2G' :
              tmpChartRow10YearC.SM_2G = item.CNT;
              tmpChartRow10YearC.SM_2G_str = insertComma(item.CNT);
              break;
            case '3G' :
              tmpChartRow10YearC.SM_3G = item.CNT;
              tmpChartRow10YearC.SM_3G_str = insertComma(item.CNT);
              break;
            case 'LTE' :
              tmpChartRow10YearC.SM_LTE = item.CNT;
              tmpChartRow10YearC.SM_LTE_str = insertComma(item.CNT);
              break;
            case '5G' :
              tmpChartRow10YearC.SM_5G = item.CNT;
              tmpChartRow10YearC.SM_5G_str = insertComma(item.CNT);
              break;
            // no default
          }

          maxYear = item.YEARMM;
        }
      }
    }
    //minYear는 일단 계산하고나서 차트 상단 타이틀에 년도~ 표시할때는 +1하기 위해서
    if (searchChk === "Y") {
      minYear *= 1;
      minYear = minYear + 1;
    } else {
      minYear = secondMonth;
    }

    if (dataList.length > 0) {
      tmpAry10YearC.push(tmpChartRow10YearC);
    }

    if (tmpAry10YearC !== null && tmpAry10YearC.length > 0) _staData10YearChart = tmpAry10YearC;
    return _staData10YearChart;
  } else {
    return [];
  }
};

// 서비스별 무선국 수
const getChart1Layout = (prm_check, searchEnd) => {

  let title = searchEnd.substr(0,4) + "년";

  let layoutStr = '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="19" text="서비스별 무선국 수"/>'
    //+'<Caption fontSize="19" text="서비스별 무선국 수 &lt;a href=javascript:cartDownload(\'chart1\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart1\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + title + ')"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Bar3DChart showDataTips="true" barWidthRatio="0.48">'
    + '<horizontalAxis>'
    + '<LinearAxis id="hAxis" formatter="{numfmt}" title="무선국 수" labelJsFunction="labelFuncNum"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<CategoryAxis id="vAxis" categoryField="LEG_DNR_NM" title="지역" labelJsFunction="labelFunc2"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="false" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>'
    /*
  type 속성을 stacked로 변경
     type속성으로는
    clustered : 일반적인 다중데이터(차트의 멀티시리즈)방식으로 데이터를 표현합니다.(Default)
   stacked : 데이터를 위에 쌓아 올린 방식으로 표현 합니다.
     overlaid : 수치 데이터 값을 겹쳐서 표현 합니다. 주로 목표 위치와 현재 위치를 나타낼 때 많이 쓰입니다.
     100% : 차트의 수치 데이터를 퍼센티지로 계산 후 값을 퍼센티지로 나타냅니다.
   */
    + '<Bar3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" color="#666" labelYOffset="-1" labelXOffset="5">'
    + '<series>'
    /* Bar3D Stacked 를 생성시에는 Bar3DSeries를 최소 2개 정의합니다 */
  ;

  for (let i = 0; i < prm_check.length; i++) {
    layoutStr +=
      '<Bar3DSeries labelPosition="inside" showValueLabels="[]" xField="SM_' + prm_check[i] + '" displayName="' + prm_check[i] + '" color="#ffffff" insideLabelYOffset="-2">'
      + '<fill>'
      + '<SolidColor color="' + chartColor(prm_check[i]) + '"/>'
      + '</fill>'
      + '<showDataEffect>'
      + '<SeriesInterpolate/>'
      + '</showDataEffect>'
      + '</Bar3DSeries>';
  }

  layoutStr +=
    '</series>'
    + '</Bar3DSet>'
    + '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="vertical"  enableZooming="true" enableCrossHair="false"></CrossRangeZoomer>'
    + '</annotationElements>'
    + '</Bar3DChart>'
    + '<Style>'
      + '.title{ color: 0x4691E1; fontSize: 15; fontWeight: bold; }'
    + '</Style>'
    + '</rMateChart>';

  return layoutStr;
};


// 년월간 서비스별 무선국 수 변동
const getChart2Layout = (searchStart, searchEnd, searchChk, prm_check) => {
  let title1 =  "서비스별 무선국 변동";
  let title2 = searchEnd.substr(0, 4) + "년";

  if (searchStart !== "" && searchEnd !== "") {
    title1 = "년간  서비스별 무선국 변동";
    if (searchChk === 'Y') {
      title2 = searchStart.substr(0, 4) + " ~ " + searchEnd.substr(0, 4) + "년";

    } else {
      if (searchStart !== searchEnd) {
        title2 = searchStart.substr(0, 4) + " ~ " + searchEnd.substr(0, 4) + "년";
      } else {
        title2 = searchEnd.substr(0, 4) + "년";
      }
    }
  }

  let layoutStr10Year = '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="19" text="' + title1 + '  "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + title2 + ')"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Column3DChart showDataTips="true" columnWidthRatio="0.4">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="hAxis" categoryField="YEAR" title="변동 년도" labelJsFunction="chartLabelYear"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis" formatter="{numfmt}" title="무선국수" labelJsFunction="labelFuncNum"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  /*
type 속성을 stacked로 변경
   type속성으로는
  clustered : 일반적인 다중데이터(차트의 멀티시리즈)방식으로 데이터를 표현합니다.(Default)
 stacked : 데이터를 위에 쌓아 올린 방식으로 표현 합니다.
   overlaid : 수치 데이터 값을 겹쳐서 표현 합니다. 주로 목표 위치와 현재 위치를 나타낼 때 많이 쓰입니다.
   100% : 차트의 수치 데이터를 퍼센티지로 계산 후 값을 퍼센티지로 나타냅니다.
 */
  layoutStr10Year += '<Column3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" labelYOffset="-5">'
    + '<series>'
  for (let i = 0; i < prm_check.length; i++) {

    layoutStr10Year += '<Column3DSeries yField="SM_' + prm_check[i] + '" displayName="' + prm_check[i] + '" lineToEachItems="true" showLinkLabels="false">'
      /* lineToEachItems : True로 설정 하면 Series간에 선을 이어준다 */
      + '<fill>'
      + '<SolidColor color="' + chartColor(prm_check[i]) + '"/>'
      // +'<SolidColor color="#fabc05"/>'
      + '</fill>'
      + '<lineStroke>'
      + '<Stroke weight="1" color="' + chartColor(prm_check[i]) + '"/>'
      // +'<Stroke weight="1" color="#fabc05"/>'
      + '</lineStroke>'
      + '<showDataEffect>'
      + '<SeriesInterpolate/>'
      + '</showDataEffect>'
      + '</Column3DSeries>';
  }
  layoutStr10Year += '</series>'
    + '</Column3DSet>'
    + '</series>'
    + '</Column3DChart>'
    + '<Style>'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';
  return layoutStr10Year;
};

window.chartLabelYear = function(index, value) {
  console.log(value);
  if(value.length === 4 && Number.isInteger(Number(value))) {
    return '<font size="15">' + value + '년</font>';
  } else if(value.length === 6 && Number.isInteger(Number(value))) {
    return '<font size="15">' + value.substring(4, 6) + '월</font>';
  } else {
    return '<font size="15">' + value + '</font>';
  }
}

export default RMateChartStatsCellular;
